import { applicationUserSchema } from './application-user.schema';
import { z } from 'zod/v4';

export const webApplicationSchema = z.object({
  applicationDisplayName: z.string(),
  applicationId: z.number(),
  applicationName: z.string(),
  internalUseOnly: z.boolean().optional(),
  users: z.array(applicationUserSchema).optional(),
});

export type WebApplication = z.infer<typeof webApplicationSchema>;
